import CodeUtil from '../util/CodeUtil';
import { CODE_GROUP_ID } from '../constant/Constant';

// Grid 나 Modal 에 영역을 가지고 들어가는 경우
const StatusTextIconBox = ({ title, size, codeGroup, statusCd }) => {
    return (
        <div
            className={
                'form-box' +
                (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
            }
        >
            <div className='input-box'>
                <label htmlFor={title}>{title}</label>
                <div className='span-txt-icon'>
                    <span className={getStatusClassName(codeGroup, statusCd)}>
                        {statusCd && CodeUtil.getCodeName(codeGroup, statusCd)}
                    </span>
                </div>
            </div>
        </div>
    );
};

// 아이콘만 표시하는 경우
export const StatusSpanIconBox = ({ codeGroup, statusCd }) => {
    return (
        <div className='span-status-icon'>
            <span className={getStatusClassName(codeGroup, statusCd)}>
                {statusCd && CodeUtil.getCodeName(codeGroup, statusCd)}
            </span>
        </div>
    );
};

// CODE_GROUP_ID.ENROLMENT_VALID_STATUS	수강신청검증상태	WAITING	대기
// ENROLMENT_VALID_STATUS	수강신청검증상태	APPROVE	승인
// ENROLMENT_VALID_STATUS	수강신청검증상태	REJECT	반려
//
// CODE_GROUP_ID.ENROLMENT_REG_STATUS	수강신청등록상태	WAITING	대기
// ENROLMENT_REG_STATUS	수강신청등록상태	REGIST	등록
// ENROLMENT_REG_STATUS	수강신청등록상태	REJECT	반려
// ENROLMENT_REG_STATUS	수강신청등록상태	WITHDRAW	수강취소
//
// CODE_GROUP_ID.USER_REG_VALID_STATUS	사용자등록검증상태	WAITING	교직원확인전
// USER_REG_VALID_STATUS	사용자등록검증상태	CONFIRM	교직원확인완료

const getStatusClassName = (codeGroup, statusCd) => {
    switch (codeGroup) {
        case CODE_GROUP_ID.ENROLMENT_VALID_STATUS:
            switch (statusCd) {
                case 'WAITING':
                    return 'green';

                case 'APPROVE':
                    return 'blue';

                case 'REJECT':
                    return 'red';

                default:
                    return 'gray';
            }
            break;

        case CODE_GROUP_ID.ENROLMENT_REG_STATUS:
            switch (statusCd) {
                case 'WAITING':
                case 'CANCEL-REQ':
                    return 'green';

                case 'REGIST':
                case 'CANCEL-DONE':
                    return 'blue';

                case 'REJECT':
                    return 'orange';

                case 'WITHDRAW':
                    return 'red';

                default:
                    return 'gray';
            }
            break;

        case CODE_GROUP_ID.USER_REG_VALID_STATUS:
            switch (statusCd) {
                case 'WAITING':
                    return 'green';

                case 'CONFIRM':
                    return 'blue';

                default:
                    return 'gray';
            }
            break;

        default:
            return 'gray';
    }
};

export default StatusTextIconBox;
